import axios from 'axios';
import pathfinder from '@fiverr-private/pathfinder';

interface CreateConversationResponse {
    artifacts: { artifactId: string }[];
}

/**
 * Creates an agentic job-post conversation and resolves with the brief id carried on the
 * conversation's first artifact. Calls the ai_agents create-conversation endpoint directly —
 * the full `ai_communications_sdk` client is only needed for live chat (streaming, block
 * rendering), not for this single POST; the composer page owns the actual conversation.
 */
export const createAgenticBriefConversation = async (): Promise<string> => {
    const url = pathfinder('ai_agents_create_conversation', {
        agentId: 'job-post-brief',
        apiVersion: 'v1',
    });

    const { data } = await axios.post<CreateConversationResponse>(url);
    const briefArtifact = Array.isArray(data?.artifacts) ? data.artifacts[0] : undefined;

    if (!briefArtifact) {
        throw new Error('createAgenticBriefConversation: conversation was created without a brief artifact');
    }

    return briefArtifact.artifactId;
};
